import React from 'react';
import Layout from 'components/layout';
import SEO from 'components/seo';

// Component
import ContactOptionsBlock from 'components/organisms/Blocks/ContactOptionsBlock/ContactOptionsBlock';
import FormBlock from 'components/organisms/Blocks/FormBlock/FormBlock';
import ContactForm from 'components/molecules/Forms/ContactForm/ContactForm';

// Data
import ContactData from 'data/ContactData/ContactData.json';

const ContactPage = () => (
  <Layout>
    <ContactOptionsBlock
      data={ContactData.contactOptions}
      listButtons={ContactData.contactOptions.listButtons}
    />
    <FormBlock>
      <ContactForm />
    </FormBlock>
  </Layout>
);

export default ContactPage;

export const Head = () => (
  <SEO title="Contact" />
);
